import React from 'react';

import { LoadableAfterPaint } from '@confluence/loadable';

import { BasicContentNudge } from './BasicContentNudge';

export const OnboardingNudge = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-OnboardingNudgeTooltip" */ './OnboardingNudgeTooltip'
			)
		).OnboardingNudge,
	loading: ({ children, renderChildrenWhileLoading }) =>
		renderChildrenWhileLoading ? <>{children}</> : null,
});

export const OnboardingCTANudge = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-OnboardingCTANudge" */ './onboarding/OnboardingCTANudge'
			)
		).OnboardingCTANudge,
	loading: ({ children, renderChildrenWhileLoading }) =>
		renderChildrenWhileLoading ? <>{children}</> : null,
});

// It does not have a loadable to work with components of any priority
// However, this should only be used for Nth User Onboarding Content Type Nudges
export const BasicContentOnboardingNudge = (props: any) => {
	return <BasicContentNudge {...props} />;
};
